<template>
  <div>
    <div class="adminBatch">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="row">
<!--            <a class="adminBatch__link" @click.prevent="expanded = !expanded" href="">-->
              <i :class="`fa ${expandIconCss}`"></i>
              &nbsp; <router-link :to="{ path: `/client/${client.hash_id}` }" target="_blank">{{ client.name }}</router-link> / <router-link :to="{ path: `/campaigns/${campaign.hash_id}` }" target="_blank">{{ campaign.name }}</router-link> / <router-link :to="{ path: `/creatives/${creative.hash_id}/bulk` }" target="_blank">{{ creative.name }}</router-link> / {{ batchName }}
<!--            </a>-->
            <queue-nav :index="index" :name="batchName" :id="batchId" :jobs="renderBatches" :moveUp="parentMoveUp" :moveDown="parentMoveDown" :remove="parentRemove" type="batch" />
          </div>
          <div class="row additional-stats">
            <i :class="`fa fa-paper-plane-o`"></i>&nbsp;Renders Requested: <span class="green">{{ renders_requested }}</span>
            &nbsp;
            &nbsp;
            <i :class="`fa fa-clock-o`"></i>&nbsp;Time Started: <span class="green">{{ time_started }}</span>
            &nbsp;
            &nbsp;
            <i :class="`fa fa-user-o`"></i>&nbsp;Created By: <span class="green">{{ user.name }}</span>
          </div>
        </div>
        <div v-for="(queue, i) in queues" :key="queue.name" class="adminBatch__panel panel-body" v-if="expanded">
          <div class="adminBatch__name">
            <span>{{ queue.type }}: </span>
            {{ queue.name }}
          </div>
          <progress-bar :value="queue.progress" />
          <queue-nav :index="i" :id="queue.id" :name="queue.name" :jobs="queues" :moveUp="parentMoveUp" :moveDown="parentMoveDown" :remove="parentRemove" type="queue" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ProgressBar from '@/components/ProgressBar/progress-bar'
import {renderMixin} from '@/mixins/renderMixin'
import QueueNav from './admin-queue-nav'
export default {
  name: 'AdminBatch',
  mixins: [ renderMixin ],
  components: {
    QueueNav,
    Heading,
    ProgressBar
  },
  props: {
    name: String,
    batchId: Number,
    batchName: String,
    queues: Array,
    parentMoveUp: Function,
    parentMoveDown: Function,
    parentRemove: Function,
    index: Number,
    user: {
      type: Object
    },
    client: {
      type: Object
    },
    campaign: {
      type: Object
    },
    creative: {
      type: Object
    },
    type: {
      type: String
    },
    time_started: {
      type: String
    },
    renders_requested: {
      type: Number
    }
  },
  mounted () {},
  computed: {
    expandIconCss () {
      return this.expanded ? 'fa-minus-square' : 'fa-plus-square'
    }
  },
  data: () => ({
    expanded: true
  })
}
</script>

<style lang="scss">
    @import "./admin-batch";
</style>



// WEBPACK FOOTER //
// src/components/AdminBatch/admin-batch.vue